import React from 'react';
import { useParams } from 'react-router-dom';
import { SaleMandateDetail } from '../components/mandates/SaleMandateDetail';

export function SaleMandateDetailPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;

  return (
    <>
      <div style={{
        background: 'var(--surface)',
        borderBottom: '1px solid var(--border)',
        padding: '0 28px',
        height: '56px',
        display: 'flex',
        alignItems: 'center',
      }}>
        <div>
          <div style={{ fontSize: '15px', fontWeight: 500 }}>Verkaufsmandat</div>
          <div style={{ fontSize: '12px', color: 'var(--text3)', marginTop: '1px' }}>Details, Matching &amp; Versendungen</div>
        </div>
      </div>
      <div className="content">
        <SaleMandateDetail id={id} />
      </div>
    </>
  );
}
